import {
  GET_ADMIN_CHANGE_HISTORY_FILTERS,
  GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR,
  GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS,
} from "./actionTypes"

const initialState = {
  accounts: [],
  brands: [],
  campaigns: [],
  users: [],
  admin_users: [],
  change_location_options: [],
  change_action_options: [],
  // one flag per dropdown - each endpoint resolves on its own
  loading: {},
  errors: {},
}

const FILTER_KEYS = [
  'accounts',
  'brands',
  'campaigns',
  'users',
  'admin_users',
  'change_location_options',
  'change_action_options',
]

const AdminChangeHistoryFilters = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_CHANGE_HISTORY_FILTERS:
      return {
        ...state,
        loading: FILTER_KEYS.reduce((acc, key) => ({ ...acc, [key]: true }), {}),
        errors: {},
      }

    case GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS: {
      const { filterKey, data } = action.payload
      return {
        ...state,
        [filterKey]: data || [],
        loading: { ...state.loading, [filterKey]: false },
      }
    }

    case GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR: {
      const { filterKey, error } = action.payload
      return {
        ...state,
        loading: { ...state.loading, [filterKey]: false },
        errors: { ...state.errors, [filterKey]: error },
      }
    }

    default:
      return state
  }
}

export default AdminChangeHistoryFilters
